import React, { useState } from "react";
import { MoveHouseDetails } from "../MoveHouseDetails";
import DashboardInventoryList, {
  EditInventoryOnCallBack,
} from "../DashboardInventoryList";
import { AdditionalInformation } from "../AdditionalInformation";
import Immutable from "immutable";
import momentTimeZone from "moment-timezone";
import {
  AddressInfo,
  MoveItemsInfo,
  EstimateMoveDate,
} from "../estimate_details/MoveDetails";
import navigationsLinks from "../../../constants/navigation_links";
import { useHistory } from "react-router";
import config from "../../../config/config";
import {
  getUserInfoFromSession,
  updateCheckOutInfoSession,
} from "../../../adapters/session/localSessionAdapter";
import {
  generatePaymentOrder,
  notifyPayment,
} from "../../../adapters/payment/payment";
import { StorageItems } from "../../inventory/StorageItems";
import { InvoiceList } from "../estimate_details/InvoiceList";
export default function EstimateBooked(props) {
  const { data, setProgressModal, setListOfGoods } = props;
  const [showMoveDetails, setShowMoveDetails] = useState(false);
  const history = useHistory();
  //callback 0 or 1 check for move type.
  const inventoryData = Immutable.fromJS(data.items);
  const clientTz = momentTimeZone.tz.guess();

  const moveDate = momentTimeZone.utc(data.moving_on).tz(clientTz);
  const showMoveDetailsFn = (params) => {
    setShowMoveDetails(!showMoveDetails);
  };
  const closeProgressModal = () => {
    setProgressModal({ status: false, text: "" });
  };

  const estimateAmount = data.estimateAmount;
  const balance = parseFloat(estimateAmount["balance"]);
  const additionalAmount = parseFloat(estimateAmount["additional_amount"]);
  const total = parseFloat(estimateAmount["invoiceAmount"]);
  const paid = parseFloat(estimateAmount["paid"]);
  const vendorId = estimateAmount["vendor_id"];

  const handleBalancePayment = async () => {
    setProgressModal({ status: true, text: "Loading payment gateway..." });
    const session = getUserInfoFromSession();

    const requestPayload = {
      customer_id: session["user_id"],
      estimate_id: data.estimate_id,
      payment_type: "balance",
      invoice_amount: balance,
      payment_gateway: "razorpay",
      vendor_id: vendorId,
    };
    const completeInfo = {
      fromAddress: data["from_address"],
      toAddress: data["to_address"],
      propertySize: data["property_size"],
      amount: balance,
      movingOn: data["moving_on"],
      paymentType: "balance",
      vendorName: estimateAmount["business_name"],
    };
    try {
      const response = await generatePaymentOrder(requestPayload);
      if (response.status === 200) {
        if (response.data.meta.code === 200) {
          const gateway_response = response.data.data.gateway_response;
          closeProgressModal();
          razorpay(
            gateway_response,
            parseInt(balance) * 100,
            completeInfo,
            session
          );
        }
      }
    } catch (e) {
      //TODO:handle error message
      console.error("An error occurred", e);
    }
  };

  function razorpay(order_id, amount, completeInfo, session) {
    const phone = session["phone"];
    const name = session["customerName"];
    const email = session["email"];
    const logo = `${config.customerPortal}assets/images/icons/boxigo-icon.png`;
    const options = {
      key: process.env.REACT_APP_RAZORPAY_ID,
      amount: amount,
      currency: "INR",
      name: "Boxigo",
      description: "Payment Transaction",
      image: logo,
      order_id: order_id,
      handler: function (response) {
        response.amount = amount;
        paymentStatusHandler(response, completeInfo);
      },
      prefill: {
        name: name,
        email: email,
        contact: phone,
      },
      theme: {
        color: "#EE553B",
      },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  }
  const paymentStatusHandler = async (response, completeInfo) => {
    setProgressModal({ status: true, text: "Processing payment..." });
    try {
      const res = await notifyPayment(response);
      if (res.status === 200) {
        if (res.data.meta.code === 200 && res.data.meta.status === "OK") {
          updateCheckOutInfoSession(completeInfo);
          closeProgressModal();
          history.push(navigationsLinks.payment_success_page);
        } else {
          closeProgressModal();
          //handle error message.
          console.error("An error occurred", res);
        }
      }
    } catch (e) {
      closeProgressModal();
      //handle error message.
      console.error("An Error occurred", e);
    }
  };
  const JSX = (
    <div className="move-container">
      <AddressInfo
        movingFrom={data.moving_from}
        movingTo={data.moving_to}
        fromAddress={data.from_address}
        toAddress={data.to_address}
        estimateId={data.estimate_id}
        estimateDetails={data}
      />
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4 dashboard-item-common-spacing">
          <MoveItemsInfo
            propertySize={data.property_size}
            callback={data.call_back}
            totalItems={data.total_items}
            items={data.items}
            serviceType={data.service_type}
            inventoryData={inventoryData}
            distance={data.distance}
          />
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 dashboard-item-common-spacing">
          <EstimateMoveDate
            moveDateObj={moveDate}
            moveDateFlexible={data.move_date_flexible}
            handleMoveDateUpdate={() => {}}
            editDisabled={true}
          />
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 move-action-list dashboard-item-common-spacing">
          <div className="d-flex flex-row">
            <button
              onClick={showMoveDetailsFn}
              className="btn btn-sm w-100 light-btn"
            >
              View Move Details
            </button>
            <button className="btn btn-primary btn-sm ml-2 w-100">
              {data.custom_status}
            </button>
          </div>
        </div>
      </div>
      <div className="row my-2">
        <div className="col-sm-12 col-md-12 col-lg-4 dashboard-item-common-spacing order-level-1">
          <div className="d-flex justify-content-between order-payment-details">
            <div>
              <div className="p-label">Total</div>
              <div className="p-data">{`₹ ${total}`}</div>
            </div>
            <div>
              <div className="p-label">Paid</div>
              <div className="p-data">{`₹ ${paid}`}</div>
            </div>
            {balance > 0 && (
              <div>
                <div className="p-label">
                  {balance > 0 && additionalAmount === 0
                    ? "Balance"
                    : "Additional Balance"}
                </div>
                <div className="p-data">{`₹ ${balance}`}</div>
              </div>
            )}
            {estimateAmount["debit"] > 0 && (
              <div>
                <div className="p-label">Refund</div>
                <div className="p-data">{`₹ ${estimateAmount["debit"]}`}</div>
              </div>
            )}
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 dashboard-item-common-spacing order-level-2">
          <div class="d-flex justify-content-end align-items-center">
            <img
              class="mr-2"
              alt="..."
              src={`${config.customerPortal}/includes/img/customerDashboard/vendor_truck.png`}
            />
            <span class="font-size-md mb-0">
              {estimateAmount["business_name"]}
            </span>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-4 move-action-list dashboard-item-common-spacing order-level-3">
          <div className="d-flex flex-row">
            {balance > 0 ? (
              <button
                className="btn btn-primary btn-sm w-100 mr-2"
                onClick={() => handleBalancePayment()}
              >
                Pay Balance
              </button>
            ) : (
              <div className="btn-sm w-100"></div>
            )}
            <InvoiceList
              balance={balance}
              additionalAmount={additionalAmount}
              estimateData={data}
              estimateStatus={4}
              setListOfGoods={setListOfGoods}
            />
          </div>
        </div>
      </div>

      {/* View Move Details */}
      {showMoveDetails === true && (
        <div className="row">
          <div className="col-12">
            <AdditionalInformation
              additionalInfo={data.old_house_additional_info}
              estimateId={data.estimate_id}
              editDisabled={true}
            />
            <MoveHouseDetails moveData={data} editDisabled={true} />
            {data.call_back === "0" && data.service_type === "relocation" && (
              <DashboardInventoryList
                estimateId={data.estimate_id}
                inventoryItems={inventoryData}
                propertySize={data.property_size}
                editDisabled={true}
              />
            )}
            {data.call_back === "1" && data.service_type === "relocation" && (
              <EditInventoryOnCallBack editDisabled={true} />
            )}
            {data.call_back === "1" && data.service_type === "storage" && (
              <StorageItems
                items={data.storage_items}
                estimateId={data.estimate_id}
                editDisabled={true}
              />
            )}
          </div>
        </div>
      )}
      <hr />
    </div>
  );
  return JSX;
}
